export default "__VITE_ASSET__Bet263IP__"